<div class="sb-widget-button-bar">
    <button
        class="btn secondary"
        *ngFor="let button of buttons"
        (click)="buttonClicked(button)"
    >
        <mat-icon *ngIf="button.icon">{{ button.icon }}</mat-icon>
        <span>{{ button.label }}</span>
    </button>
</div>
